import { createRouter, createWebHashHistory, createWebHistory } from "vue-router"
import { Product_Info } from "@/globalcfg"

// const APP_NAME = "doubleFaced";//定义当前app名字(根据不同名字build不同页面)
const APP_NAME = "SketchPainting";//定义当前app名字(根据不同名字build不同页面)
// const APP_NAME = "FuseBeads_Test_swiper";               //定义当前app名字(根据不同名字build不同页面)
const ProductTypeCode = "009";  //当前产品类型编码（验证检查）
//公共页面
import feedback from "@/components/base/feedback"
import verify from "@/components/base/verify"
//1. 定义要使用到的路由组件
// import doubleFaced_Build from "@/3DApp/doubleFaced/build.vue"
// import doubleFaced_Guide from "@/3DApp/doubleFaced/guide.vue"

import Painting_Home from "@/Painting/home/mainhome_enworld.vue"
import Painting_Home_CHINA from "@/Painting/home/mainhome_china.vue"
import Painting_ImageTrans from "@/Painting/imagegenerate/entrance.vue"

//产品跳转页面
import Product_Main from "@/Painting/product/product_main.vue"
import Product_Dynamic from "@/Painting/product/product_dynamic.vue"
import BuildDetails from "@/Painting/buildparttern/builddetail.vue";

import i18n from "@/lang"


import Test_modal from "@/components/tools/test_modal.vue"
import Test_Menu from "@/Painting/aboutus/aboutus.vue"
// import { el } from "element-plus/es/locale";
// import FuseBeads_ImageTrans from "@/FuseBeads/imagetransfer/test_swiper.vue"
// import Image_BuildDetail from "@/components/tiny/builddetail.vue"
// import PreModeles from "@/FuseBeads/premodels/premodels_index.vue"


//2. 根据不同APP路由
const routes = function () {
    var list = []
    if (APP_NAME == "SketchPainting") {
        list = [
            { path: "/", component: Painting_Home, name: "Home" },//首页
            { path: "/home_zh", component: Painting_Home_CHINA, name: "Home_China" },//首页
            { path: "/imagetransfer", component: Painting_ImageTrans},   //图片转换页
            { path: "/test_modal", component: Test_modal},   //图片转换页
            { path: "/product", component: Product_Main, name: "ProductList"},
            { path: "/product_main", redirect: "/product"},
            { path: "/product/:slug", component: Product_Dynamic, name: "ProductDetail"},
            { path: "/about_us", component: Test_Menu},
            { path: "/build_details", component: BuildDetails},   //拼装详情页
            // { path: "/build_detail", component: Image_BuildDetail},   //拼装详情页
            // { path: "/premodels", component: PreModeles},   //预制模型页
        ]

        Object.keys(Product_Info).forEach(key => {
            const info = Product_Info[key]
            const legacyPath = info.path
            const slug = (info.key || info.path || key).toLowerCase()
            if (legacyPath) {
                list.push({
                    path: "/" + legacyPath,
                    redirect: `/product/${slug}`
                })
            }
        })
    }
    
    //3，添加公共路由
    list.push({ path: "/verify", component: verify, name: "Verify" });//验证页面
    list.push({ path: "/feedback", component: feedback });
    return list;
}();




// 3. 创建路由实例
const router = createRouter({
    // （1）采用hash 模式
    // history: createWebHashHistory(),
    // （2）采用 history 模式
    history: createWebHistory(),
    routes, //使用上方定义的路由配置
})
//状态记录，这里简单处理
var verifySuccessfully = true;
//验证访问权限
router.beforeEach((to, from, next) => {

    let verify_result = sessionStorage.getItem("verifySuccessfully");

    if (verify_result != null) 
    {
        verifySuccessfully = true;
    }


    //访问没有验证
    if (!verifySuccessfully) {
        // 访问首页、图片转换页、预制模型页都需要验证
        if (to.path == '/' || to.path == '/imagetransfer' /*|| to.path == '/premodels'*/) {

            if (to.params.verifySuccessfully) {
                verifySuccessfully = true;
                next();
            }
            else {
                //跳转到验证页面
                var params = {
                    QRCode: to.query.QRCode,
                    demoPath: to.query.demoPath,
                    ProductTypeCode: ProductTypeCode,
                }
                //带上query，防止刷新验证参数丢失
                next({ path: '/verify', name: "Verify", params: params});
            }
        }
        else {
            //其他页面不做限制
            next();
        }
    }
    else {
        if (to.path === '/')
        {
            const userLanguage = i18n.global.locale.value;
            if (userLanguage === 'zh') {
                next({ path: '/home_zh', name: "Home_China"});
                return;
            }
            
        }
        next();
    }
})

// 4. 导出router
export default router